import { useRef, useState } from "react";
import PunchMatteImage from "./PunchMatteImage";
import { useDomPin } from "./useDomPin";
import s from "./createAppLanding.module.css";

const SCREENS = [
  {
    id: "home",
    title: "Главная",
    text: "Баланс, ближайшая тренировка, ответ «буду».",
    src: "/landing/mock-client-home.png",
  },
  {
    id: "calendar",
    title: "Календарь",
    text: "Расписание: зал, тренер, время.",
    src: "/landing/mock-client-calendar.png",
  },
  {
    id: "chat",
    title: "Чат",
    text: "Переписка группы внутри клуба.",
    src: "/landing/mock-client-chat.png",
  },
  {
    id: "profile",
    title: "Профиль",
    text: "Абонемент и достижения.",
    src: "/landing/mock-client-profile.png",
  },
];

const TAU = Math.PI * 2;

/**
 * 3D ring carousel: 1 front, 2 sides (mid), 1 back.
 * Scroll rotates the ring — phones stay upright (rotateY only).
 */
export default function ClientsNeed() {
  const railRef = useRef(null);
  const panelRef = useRef(null);
  const phoneRefs = useRef([]);
  const [meta, setMeta] = useState({
    title: SCREENS[0].title,
    text: SCREENS[0].text,
  });
  const metaIdx = useRef(0);

  useDomPin(railRef, panelRef, (p) => {
    const n = SCREENS.length;
    // Full turn of the ring
    const spin = p * TAU;
    let best = 0;
    let bestDepth = -Infinity;

    const mobile = window.innerWidth < 700;
    const rx = mobile
      ? Math.min(window.innerWidth * 0.34, 150)
      : Math.min(window.innerWidth * 0.28, 320);
    const rz = mobile ? 90 : 180;

    phoneRefs.current.forEach((el, i) => {
      if (!el) return;
      // Evenly spaced on the circle
      const a = spin + (i / n) * TAU;
      const x = Math.sin(a) * rx;
      const z = Math.cos(a) * rz; // +z = front (toward camera)
      // Side phones turn around Y — not tipped into one point
      const rotY = -Math.sin(a) * (mobile ? 42 : 52);
      const depth = Math.cos(a); // 1 front … -1 back
      const t = (depth + 1) / 2; // 0 back → 1 front
      const scale = 0.62 + t * 0.42;
      const opacity = 0.4 + t * 0.6;

      el.style.opacity = String(opacity);
      el.style.zIndex = String(Math.round(10 + depth * 20));
      el.style.transform = `translate(-50%, -50%) translate3d(${x}px, 0, ${z}px) rotateY(${rotY}deg) scale(${scale})`;

      if (depth > bestDepth) {
        bestDepth = depth;
        best = i;
      }
    });

    if (best !== metaIdx.current) {
      metaIdx.current = best;
      setMeta({ title: SCREENS[best].title, text: SCREENS[best].text });
    }
  });

  return (
    <section
      id="clients"
      ref={railRef}
      className={s.orbitRail}
      aria-label="Клиентам"
    >
      <div ref={panelRef} className={s.orbitInner}>
        <div className={s.orbitHead}>
          <p className={s.orbitEyebrow}>Приложение ученика</p>
          <h2 className={s.orbitTitle}>Всё, что нужно клиентам</h2>
        </div>

        <div className={s.orbitStage}>
          {SCREENS.map((item, i) => (
            <figure
              key={item.id}
              ref={(el) => {
                phoneRefs.current[i] = el;
              }}
              className={s.orbitPhone}
            >
              <PunchMatteImage
                src={item.src}
                alt={item.title}
                className={s.orbitPhoneImg}
              />
            </figure>
          ))}
        </div>

        <div className={s.orbitMeta} aria-live="polite">
          <h3>{meta.title}</h3>
          <p>{meta.text}</p>
        </div>
      </div>
    </section>
  );
}
